import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { T as TouchLinkButton, b as TouchLinkAnchor } from './TouchLink.styles-B5B1gO5F.js';
import { T as TouchLinkBody } from './TouchLinkBody-BIV4FyYx.js';
import { a as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-C6vdL-6Z.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

const TouchLink = ({
  children,
  href,
  onClick,
  taktId,
  taktValue
}) => {
  if (onClick) {
    return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
      taktId: taktId,
      taktValue: taktValue,
      fallbackId: createStormTaktId('touch-link')
    }, ({
      getDataTaktAttributes
    }) => /*#__PURE__*/React__default.createElement(TouchLinkButton, _extends({
      onClick: onClick
    }, getDataTaktAttributes()), /*#__PURE__*/React__default.createElement(TouchLinkBody, null, children)));
  }
  return /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
    taktId: taktId,
    taktValue: taktValue,
    fallbackId: createStormTaktId('touch-link')
  }, ({
    getDataTaktAttributes
  }) => /*#__PURE__*/React__default.createElement(TouchLinkAnchor, _extends({
    href: href
  }, getDataTaktAttributes()), /*#__PURE__*/React__default.createElement(TouchLinkBody, null, children)));
};

export { TouchLink as T };
//# sourceMappingURL=TouchLink-CeDQ8ERv.js.map
